const _temp0 = require("../../intl/spinbutton/ar-AE.json");
const _temp1 = require("../../intl/spinbutton/bg-BG.json");
const _temp2 = require("../../intl/spinbutton/cs-CZ.json");
const _temp3 = require("../../intl/spinbutton/da-DK.json");
const _temp4 = require("../../intl/spinbutton/de-DE.json");
const _temp5 = require("../../intl/spinbutton/el-GR.json");
const _temp6 = require("../../intl/spinbutton/en-US.json");
const _temp7 = require("../../intl/spinbutton/es-ES.json");
const _temp8 = require("../../intl/spinbutton/et-EE.json");
const _temp9 = require("../../intl/spinbutton/fi-FI.json");
const _temp10 = require("../../intl/spinbutton/fr-FR.json");
const _temp11 = require("../../intl/spinbutton/he-IL.json");
const _temp12 = require("../../intl/spinbutton/hr-HR.json");
const _temp13 = require("../../intl/spinbutton/hu-HU.json");
const _temp14 = require("../../intl/spinbutton/it-IT.json");
const _temp15 = require("../../intl/spinbutton/ja-JP.json");
const _temp16 = require("../../intl/spinbutton/ko-KR.json");
const _temp17 = require("../../intl/spinbutton/lt-LT.json");
const _temp18 = require("../../intl/spinbutton/lv-LV.json");
const _temp19 = require("../../intl/spinbutton/nb-NO.json");
const _temp20 = require("../../intl/spinbutton/nl-NL.json");
const _temp21 = require("../../intl/spinbutton/pl-PL.json");
const _temp22 = require("../../intl/spinbutton/pt-BR.json");
const _temp23 = require("../../intl/spinbutton/pt-PT.json");
const _temp24 = require("../../intl/spinbutton/ro-RO.json");
const _temp25 = require("../../intl/spinbutton/ru-RU.json");
const _temp26 = require("../../intl/spinbutton/sk-SK.json");
const _temp27 = require("../../intl/spinbutton/sl-SI.json");
const _temp28 = require("../../intl/spinbutton/sr-SP.json");
const _temp29 = require("../../intl/spinbutton/sv-SE.json");
const _temp30 = require("../../intl/spinbutton/tr-TR.json");
const _temp31 = require("../../intl/spinbutton/uk-UA.json");
const _temp32 = require("../../intl/spinbutton/zh-CN.json");
const _temp33 = require("../../intl/spinbutton/zh-TW.json");
module.exports = {
  "ar-AE": _temp0,
  "bg-BG": _temp1,
  "cs-CZ": _temp2,
  "da-DK": _temp3,
  "de-DE": _temp4,
  "el-GR": _temp5,
  "en-US": _temp6,
  "es-ES": _temp7,
  "et-EE": _temp8,
  "fi-FI": _temp9,
  "fr-FR": _temp10,
  "he-IL": _temp11,
  "hr-HR": _temp12,
  "hu-HU": _temp13,
  "it-IT": _temp14,
  "ja-JP": _temp15,
  "ko-KR": _temp16,
  "lt-LT": _temp17,
  "lv-LV": _temp18,
  "nb-NO": _temp19,
  "nl-NL": _temp20,
  "pl-PL": _temp21,
  "pt-BR": _temp22,
  "pt-PT": _temp23,
  "ro-RO": _temp24,
  "ru-RU": _temp25,
  "sk-SK": _temp26,
  "sl-SI": _temp27,
  "sr-SP": _temp28,
  "sv-SE": _temp29,
  "tr-TR": _temp30,
  "uk-UA": _temp31,
  "zh-CN": _temp32,
  "zh-TW": _temp33
}